var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Container from "@/models/Container";
import Item from "@/models/Item";
import * as firebase from "firebase";
import Vue from 'vue';
require('firebase/firestore');
var FirebaseDAO = /** @class */ (function () {
    function FirebaseDAO(options) {
        var _this = this;
        this.app = firebase.initializeApp(options);
        this.db = this.app.firestore();
        this.auth = new Promise(function (resolve) {
            _this.app.auth().onAuthStateChanged(function (user) {
                _this.user = user;
                resolve(user);
            });
        });
        var settings = { timestampsInSnapshots: true };
        this.db.settings(settings);
    }
    FirebaseDAO.install = function (vue, options) {
        var dao = new FirebaseDAO(options);
        Object.defineProperty(Vue.prototype, '$dao', {
            get: function () { return dao; }
        });
    };
    FirebaseDAO.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.user;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.auth];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a];
                }
            });
        });
    };
    FirebaseDAO.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.app.auth().signInWithEmailAndPassword(email, password)];
            });
        });
    };
    FirebaseDAO.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.user = null;
                return [2 /*return*/, this.app.auth().signOut()];
            });
        });
    };
    FirebaseDAO.prototype.saveContainer = function (container) {
        return __awaiter(this, void 0, void 0, function () {
            var data, containerRef;
            return __generator(this, function (_a) {
                if (!this.user) {
                    return [2 /*return*/, false];
                }
                data = {
                    name: container.name,
                    type: container.type,
                    idUser: this.user.uid
                };
                if (container.id) {
                    containerRef = this.db.collection('containers').doc(container.id);
                    return [2 /*return*/, containerRef.set(data, { merge: true })];
                }
                return [2 /*return*/, this.db.collection("containers").add(data)];
            });
        });
    };
    FirebaseDAO.prototype.getItemById = function (id, container) {
        return __awaiter(this, void 0, void 0, function () {
            var itemRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection("containers/" + container + "/items").doc(id).get()];
                    case 1:
                        itemRef = _a.sent();
                        if (itemRef.exists) {
                            return [2 /*return*/, this.dbDataToItem(itemRef, container)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FirebaseDAO.prototype.saveItem = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var image, data, itemRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user || !item.idContainer) {
                            throw new Error('Not logged in');
                        }
                        image = item.image;
                        if (!(image instanceof File)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.saveImage(image)];
                    case 1:
                        image = _a.sent();
                        _a.label = 2;
                    case 2:
                        data = {
                            name: item.name,
                            colourGroup: item.colourGroup,
                            laundryCategory: item.laundryCategory,
                            packingCategory: item.packingCategory,
                            subcategory: item.subcategory || null,
                            idContainer: item.idContainer,
                            image: image
                        };
                        if (item.id) {
                            itemRef = this.db.collection("containers/" + item.idContainer + "/items").doc(item.id);
                            return [2 /*return*/, itemRef.set(data, { merge: true })];
                        }
                        return [2 /*return*/, this.db.collection("containers/" + item.idContainer + "/items").add(data)];
                }
            });
        });
    };
    FirebaseDAO.prototype.moveItem = function (item, to) {
        return __awaiter(this, void 0, void 0, function () {
            var itemRef, dbData, doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection("containers/" + item.idContainer + "/items").doc(item.id)];
                    case 1:
                        itemRef = _a.sent();
                        return [4 /*yield*/, itemRef.get()];
                    case 2:
                        dbData = _a.sent();
                        if (dbData.exists) {
                            doc = dbData.data();
                            doc.idContainer = item.idContainer = to.id;
                            this.db.collection("containers/" + to.id + "/items").add(doc);
                            itemRef.delete();
                        }
                        return [2 /*return*/, item];
                }
            });
        });
    };
    FirebaseDAO.prototype.deleteItem = function (item) {
        if (!this.user) {
            throw new Error('Not logged in');
        }
        return this.db.collection("containers/" + item.idContainer + "/items").doc(item.id).delete();
    };
    FirebaseDAO.prototype.getContainers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dbData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.db.collection('containers')
                                .where('idUser', '==', this.user.uid)
                                .get()];
                    case 1:
                        dbData = _a.sent();
                        return [2 /*return*/, Promise.all(dbData.docs.map(function (data) {
                                var doc = data.data();
                                return new Container(doc.name, doc.type, data.id);
                            }))];
                }
            });
        });
    };
    FirebaseDAO.prototype.getContainerById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var dbData, containers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection('containers')
                                .where('idUser', '==', this.user.uid)
                                .where(firebase.firestore.FieldPath.documentId(), '==', id)
                                .limit(1)
                                .get()];
                    case 1:
                        dbData = _a.sent();
                        return [4 /*yield*/, Promise.all(dbData.docs.map(function (data) {
                                var doc = data.data();
                                return new Container(doc.name, doc.type, data.id);
                            }))];
                    case 2:
                        containers = _a.sent();
                        return [2 /*return*/, containers.pop()];
                }
            });
        });
    };
    FirebaseDAO.prototype.getContainerItems = function (container) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var dbData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection("containers/" + container.id + "/items").get()];
                    case 1:
                        dbData = _a.sent();
                        return [2 /*return*/, Promise.all(dbData.docs.map(function (doc) {
                                return _this.dbDataToItem(doc, container.id);
                            }))];
                }
            });
        });
    };
    FirebaseDAO.prototype.getContainerItemsOfPackingCategory = function (container, type) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var dbData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection("containers/" + container.id + "/items")
                                .where('packingCategory', '==', type).get()];
                    case 1:
                        dbData = _a.sent();
                        return [2 /*return*/, Promise.all(dbData.docs.map(function (doc) {
                                return _this.dbDataToItem(doc, container.id);
                            }))];
                }
            });
        });
    };
    FirebaseDAO.prototype.getContainerItemsCount = function (container) {
        return __awaiter(this, void 0, void 0, function () {
            var dbData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        return [4 /*yield*/, this.db.collection("containers/" + container.id + "/items").get()];
                    case 1:
                        dbData = _a.sent();
                        return [2 /*return*/, dbData.docs.length];
                }
            });
        });
    };
    FirebaseDAO.prototype.register = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.app.auth().createUserWithEmailAndPassword(email, password)];
            });
        });
    };
    FirebaseDAO.prototype.saveImage = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, storageRef, snapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user) {
                            throw new Error('Not logged in');
                        }
                        metadata = {
                            'contentType': file.type
                        };
                        storageRef = this.app.storage().ref();
                        return [4 /*yield*/, storageRef.child('images/' + file.name).put(file, metadata)];
                    case 1:
                        snapshot = _a.sent();
                        if (snapshot) {
                            // Let's get a download URL for the file.
                            return [2 /*return*/, snapshot.ref.getDownloadURL()];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    FirebaseDAO.prototype.dbDataToItem = function (data, container) {
        var doc = data.data();
        return new Item(doc.name, doc.colourGroup, doc.laundryCategory, doc.packingCategory, doc.subcategory, container, doc.image, data.id);
    };
    return FirebaseDAO;
}());
export default FirebaseDAO;



//////////////////
// WEBPACK FOOTER
// ./src/dao/FirebaseDAO.ts
// module id = null
// module chunks = 